import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { AnimatePresence, motion } from "framer-motion"

const useStyles = makeStyles()(() => ({
    box: {
        position: "relative",
        width: "100%",
        overflow: "hidden",
        height: "100%",
    },
}))

type AnimatedTabProps = Readonly<{
    activeKey: string
    tabs: Array<{
        animationKey: string
        content: React.ReactNode
        direction: "left" | "right" | string
    }>
    animationDuration?: number
}>

export function AnimatedTabWrapper({ activeKey, tabs, animationDuration = 0.5 }: AnimatedTabProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.box}>
            <AnimatePresence initial={false} mode="sync">
                {tabs.map(({ animationKey, content, direction }) =>
                    activeKey === animationKey ? (
                        <motion.div
                            key={animationKey}
                            initial={{
                                x: direction === "right" ? "100%" : "-100%",
                                opacity: 0,
                            }}
                            animate={{
                                x: 0,
                                opacity: 1,
                            }}
                            exit={{
                                x: direction === "right" ? "100%" : "-100%",
                                opacity: 0,
                            }}
                            transition={{ duration: animationDuration, ease: "easeInOut" }}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                            }}
                        >
                            {content}
                        </motion.div>
                    ) : null,
                )}
            </AnimatePresence>
        </Box>
    )
}
